export default __webpack_public_path__ + "9625600.png";